import image0 from "./images/img0.jpg";
import image1 from "./images/img1.jpg";
import image2 from "./images/img2.jpg";
import image3 from "./images/img3.jpg";
import image4 from "./images/img4.jpg";

export default [image0, image1, image2, image3, image4];
